import {newSeasonalContractsTotalCalculation} from './new-seasonal-contracts-total-calculation';

/**
 * Survey: PROJECT - BASELINE IMPACT
 * Question: How many additional seasonal employees do you employ?
 * 
 * == baseline
 * question70
 * 
 * Survey: PROJECT - FINAL IMPACT
 * Question: How many additional seasonal employees do you employ?
 * 
 * == final
 * question14
 * 
 * @param props 
 * @returns 
 */
export const newSeasonalContractsPerEntrepreneurTotalCalculation = (props: any) => {
    const baselineTotal = props.baselineSubmissions.filter((s: any) => s.question70).length;
    const finalTotal = props.finalSubmissions.filter((s: any) => s.question14).length;
    const total = Math.max(baselineTotal, finalTotal);

    return (newSeasonalContractsTotalCalculation(props) / total).toFixed(2);
}